import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import NewCheckinRegister from './NewCheckinRegister';

import axios from 'axios';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function UpdateCheckIn() {
  const location = useLocation();
  const data = location.state.selectedBooking;

  const [mobileNumber, setMobileNumber] = useState(data.mobileNo);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [address, setAddress] = useState('');
  const [cityState, setCityState] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [guestInfo, setGuestInfo] = useState(null);

  useEffect(() => {
    if (mobileNumber === data.mobileNo) {
      var fullName = data.name.split(' ');
      var firstName = fullName[0];
      var lastName = fullName.slice(1).join(' ');

      setFirstName(firstName);
      setLastName(lastName);
      setPhoneNo(data.mobileNo);
    } else {
      setFirstName('');
      setLastName('');
      setAddress('');
      setCityState('');
      setPhoneNo(mobileNumber);
    }
  }, [mobileNumber, data.mobileNo, data.name, data.address, data.city]);

  const handleGuestRegister = (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post('/api/addGuestInfo', {
        firstName,
        lastName,
        address,
        cityState,
        phoneNo,
      })
      .then(async () => {
        console.log('New Guest Added!');
        alert('New Guest Added!');

        handleClose();

        const response = await axios.post('/api/phoneLookup', {
          phone: mobileNumber,
        });

        if (response.status !== 200) {
          throw new Error('Failed to fetch data');
        }
        const data = response.data;
        if (data.results.length > 0) {
          setGuestInfo(data);
        } else {
          handleOpen();
        }
      })
      .catch((err) => {
        console.log('Error: ', err);
        alert('Error adding guest info');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleMobileNumberChange = (event) => {
    setMobileNumber(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post('/api/phoneLookup', {
        phone: mobileNumber,
      });

      if (response.status !== 200) {
        throw new Error('Failed to fetch data');
      }

      const data = response.data;

      if (data.results.length > 0) {
        setGuestInfo(data);
      } else {
        handleOpen();
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      width: '30%',
      margin: 'auto',
      // marginTop: '100px',
    },
    input: {
      marginBottom: '10px',
      display: 'block',
      padding: '5px',
      width: '100%',
    },
    submitButton: {
      padding: '8px 12px',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      width: '100%',
    },
    form: {
      maxWidth: '400px',
      margin: '0 auto',
    },
    modalTitle: {
      mt: 2,
    },
    modalContent: {
      marginBottom: '10px',
      display: 'block',
      padding: '5px',
      width: '100%',
    },
    modalButton: {
      padding: '8px 12px',
      backgroundColor: '#007bff',
      color: '#fff',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      width: '100%',
    },
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description" sx={styles.modalTitle}>
            <div>
              <h2>Register New Guest</h2>
              <form onSubmit={handleGuestRegister} style={styles.form}>
                <input
                  type="text"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  style={styles.modalContent}
                  required
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  style={styles.modalContent}
                  required
                />
                <input
                  type="text"
                  placeholder="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  style={styles.modalContent}
                  required
                />
                <input
                  type="text"
                  placeholder="City, State"
                  value={cityState}
                  onChange={(e) => setCityState(e.target.value)}
                  style={styles.modalContent}
                  required
                />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  value={phoneNo}
                  onChange={(e) => setPhoneNo(e.target.value)}
                  style={styles.modalContent}
                  required
                />
                <button
                  type="submit"
                  disabled={loading}
                  style={styles.modalButton}
                >
                  {loading ? 'Adding Guest...' : 'Add Guest'}
                </button>
              </form>
            </div>
          </Typography>
        </Box>
      </Modal>
      <div style={styles.container}>
        <form onSubmit={handleSubmit}>
          <input
            type="tel"
            id="mobileNumber"
            name="mobileNumber"
            value={mobileNumber}
            onChange={handleMobileNumberChange}
            placeholder="Enter mobile number"
            pattern="[0-9]{10}"
            style={styles.input}
            required
          />
          <button type="submit" disabled={loading} style={styles.submitButton}>
            {loading ? 'Finding....' : 'Find'}
          </button>
        </form>
      </div>
      <hr></hr>
      <div>
        <h2>CheckIn Details</h2>
        <hr></hr>
        {guestInfo && (
          <div>
            <NewCheckinRegister
              data={guestInfo}
              roomNo={data.roomNo}
              roomDetailsId={data.roomDetailsId}
              advBookingId={data.advBookingId}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default UpdateCheckIn;
